export interface StepsProp<T = any> {
  label: string;
  list: string;
  fieldName: string;
  child?: boolean;
  isInfoSection?: boolean;
  form?: T;
}
const initialForm = { id: "", title: "" };

const SteppersData: StepsProp<any>[] = [
  {
    label: "Introduction",
    fieldName: "introduction",
    isInfoSection: true,
    list: "introduction",
  },
  // company details
  {
    label: "Company Details",
    fieldName: "companyDetails",
    isInfoSection: true,
    list: "companyDetails",
  },
  {
    label: "Company",
    fieldName: "company",
    child: true,
    form: { ...initialForm, isDefault: false },
    list: "companyDetails",
  },
  {
    label: "Location",
    fieldName: "location",
    child: true,
    form: { ...initialForm, companyId: "", isDefault: false },
    list: "companyDetails",
  },
  {
    label: "Customer",
    fieldName: "customer",
    child: true,
    form: {
      ...initialForm,
      companyId: "",
      contractTerms: "",
      code: "",
      isDefault: false,
    },
    list: "companyDetails",
  },
  // ticket
  {
    label: "Ticket",
    fieldName: "ticket",
    isInfoSection: true,
    list: "ticket",
  },
  {
    label: "Category",
    list: "ticket",
    fieldName: "category",
    child: true,
    form: { ...initialForm, isDefault: false },
  },
  {
    label: "Contractors",
    list: "ticket",
    fieldName: "contractor",
    child: true,
    form: { ...initialForm, isDefault: false },
  },
  {
    label: "Intervention Type",
    list: "ticket",
    fieldName: "interventionType",
    child: true,
    form: { ...initialForm, isDefault: false },
  },
  {
    label: "Status",
    list: "ticket",
    fieldName: "status",
    child: true,
    form: {
      ...initialForm,
      order: 0,
      badgeColor: "#8D97A0",
      isDefault: false,
      isReadOnly: false,
      isCompleted: false,
    },
  },
  {
    label: "Priority",
    list: "ticket",
    fieldName: "priority",
    child: true,
    form: {
      ...initialForm,
      isDefault: false,
    },
  },
  {
    label: "Department",
    list: "ticket",
    fieldName: "department",
    child: true,
    form: {
      ...initialForm,
      isDefault: false,
    },
  },
  // asset management
  {
    label: "Asset Management",
    fieldName: "assetManagement",
    isInfoSection: true,
    list: "asset",
  },
  {
    label: "Asset Category",
    list: "asset",
    fieldName: "assetCategory",
    child: true,
    form: {
      ...initialForm,
    },
  },
  {
    label: "Asset Type",
    list: "asset",
    fieldName: "assetType",
    child: true,
    form: {
      ...initialForm,
    },
  },
  {
    label: "Asset Status",
    list: "asset",
    fieldName: "assetStatus",
    child: true,
    form: {
      ...initialForm,
      badgeColor: "#8D97A0",
    },
  },
  {
    label: "Asset Action Type",
    list: "asset",
    fieldName: "assetActionType",
    child: true,
    form: {
      ...initialForm,
    },
  },
  {
    label: "Asset Department",
    list: "asset",
    fieldName: "assetDepartment",
    child: true,
    form: {
      ...initialForm,
    },
  },
  // procurement
  {
    label: "Procurement",
    fieldName: "procurement",
    isInfoSection: true,
    list: "procurement",
  },
  {
    label: "Vendor Status",
    list: "procurement",
    fieldName: "vendorStatus",
    child: true,
    form: {
      ...initialForm,
    },
  },
  {
    label: "Purchase Order Type",
    list: "procurement",
    fieldName: "purchaseOrderType",
    child: true,
    form: {
      ...initialForm,
    },
  },
  {
    label: "Vendor",
    list: "procurement",
    fieldName: "vendor",
    child: true,
    form: {
      id: "",
      name: "",
      address: "",
      contact: "",
      notes: "",
      businessNo: "",
      taxId: "",
      vendorStatusId: "",
    },
  },

  {
    label: "Summary",
    fieldName: "summary",
    isInfoSection: true,
    list: "summary",
  },
];

export default SteppersData;
